var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "white",
    stroke: "#F1C9D1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16C24.5 17.933 22.933 19.5 21 19.5C19.067 19.5 17.5 17.933 17.5 16C17.5 14.067 19.067 12.5 21 12.5C22.933 12.5 24.5 14.067 24.5 16Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7816 17C15.7816 17.8837 15.0653 18.6 14.1816 18.6C13.298 18.6 12.5816 17.8837 12.5816 17C12.5816 16.1163 13.298 15.4 14.1816 15.4C15.0653 15.4 15.7816 16.1163 15.7816 17Z",
    stroke: "black",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9988 28.0002C28.0093 27.1035 27.8402 26.2136 27.5015 25.3821C27.1627 24.5506 26.661 23.7941 26.0253 23.1563C25.3897 22.5185 24.6328 22.0122 23.7984 21.6666C22.9641 21.321 22.0689 21.1431 21.1647 21.1431C20.2605 21.1431 19.3653 21.321 18.5309 21.6666C17.6966 22.0122 16.9397 22.5185 16.304 23.1563C15.6684 23.7941 15.1666 24.5506 14.8279 25.3821C14.4891 26.2136 14.3201 27.1035 14.3305 28.0002",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9523 20.5033C16.5787 20.2762 16.1644 20.1279 15.7335 20.0672C15.3026 20.0064 14.8637 20.0344 14.4421 20.1494C14.0206 20.2644 13.6247 20.4643 13.2776 20.7374C12.9304 21.0105 12.6389 21.3513 12.4198 21.7403C12.2007 22.1292 12.0584 22.5584 12.0012 23.0031",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26L23 26",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.91dda9b7fc6789e55441a24666fac11c.svg";
export { ForwardRef as ReactComponent };